import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">About Us</h1>
      <p>
     Lorem ipsum dolor, sit amet consectetur adipisicing elit. Assumenda nostrum unde incidunt! Nam inventore iste, harum doloremque nostrum eos tempore eligendi quidem incidunt deleniti hic saepe! Commodi officia consequatur, a nostrum qui modi dolore ipsum quidem iusto, voluptates magni atque!
    </p>
    </section>
    
  )
}

export default About
